import { IModuleRepository } from "@app/features/Module/data/moduleRepository";
import { TEditModuleViewModel } from "@app/features/Module/view/List/listModuleViewModel";

const editModuleUseCase = async (
  repository: Pick<IModuleRepository, "editModule">,
  data: TEditModuleViewModel
) => {
  await repository.editModule(data);
};

export default editModuleUseCase;
